import { isArray, isFunction, isObject } from '@hc-frontend/utils'
/*
TODO: This will be refactor with a JSON RESPONSE
*/

type ItemData = { [key: string]: unknown }
const parseObjToStringWithHyphen = (planData: ItemData) =>
  Object.keys(planData).reduce(
    (acc, key) => `${acc}${!acc ? '' : '-'}${planData[key]}`,
    ''
  )

const parseObjToStringWithComma = (planData: ItemData) =>
  Object.keys(planData).reduce(
    (acc, key) => `${acc}${!acc ? '' : ','}${planData[key]}`,
    ''
  )

function buildSpValueToString(
  data: ItemData | ItemData[],
  mapItemFn?: (item: ItemData) => ItemData,
  parseFn = parseObjToStringWithHyphen
): string {
  if (isArray(data)) {
    return data.reduce(
      (acc, item) => {
        const mappedData = isFunction(mapItemFn) ? mapItemFn(item) : item
        return `${acc}${!acc ? '' : '|'}${parseFn(mappedData)}`
      },

      ''
    )
  }
  if (isObject(data) && Object.values(data || {})?.length) {
    const mappedData = isFunction(mapItemFn) ? mapItemFn(data) : data
    return parseFn(mappedData)
  }

  return ''
}

export { buildSpValueToString, parseObjToStringWithComma }
